import React, { useCallback, useEffect, useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import { DataspaceConnector } from '../../models/DataSpace'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useSelector } from 'react-redux';
import { sectionLabelsSelector } from '../../slices/sectionsSlice';
import { RootState } from '../../store';

type Props = {
  connector?: DataspaceConnector;
  onSubmit?: (connector: DataspaceConnector) => void;
  onCancel?: () => void;
}

export default function DataSpaceConnectorForm({ connector, onSubmit, onCancel }: Props) {
  const [editingConnector, setEditingConnector] = useState<DataspaceConnector>();
  const [validated, setValidated] = useState(false);
  const sectionLabels = useSelector((state: RootState) => sectionLabelsSelector(state, "dataspace-connectors"));

  useEffect(() => {
    setEditingConnector(connector);
  }, [connector]);

  const handleSubmit = useCallback((evt: React.FormEvent<HTMLFormElement>) => {
    const form = evt.currentTarget;
    evt.stopPropagation();
    evt.preventDefault();
    setValidated(true);

    if (form.checkValidity() === true) onSubmit?.(editingConnector!);
  }, [onSubmit, editingConnector]);

  const handleFieldChange = useCallback((evt: React.ChangeEvent<HTMLInputElement>) => {
    const field = evt.target.name;
    const value = evt.target.value;

    setEditingConnector(conn => ({
      ...conn!,
      [field]: value,
    }));
  }, []);

  return (
    <Form noValidate validated={validated} onSubmit={handleSubmit}>
      <Modal.Body>
        <Form.Group className="mb-3" controlId="connector-name">
          <Form.Label>Name</Form.Label>
          <Form.Control name="name" placeholder={`${sectionLabels.singular} Name`} size="sm" value={editingConnector?.name} onChange={handleFieldChange} required />
          <Form.Control.Feedback type="invalid">{sectionLabels.singular} name is required.</Form.Control.Feedback>
        </Form.Group>

        <Form.Group className="mb-3" controlId="connector-description">
          <Form.Label>Description</Form.Label>
          <Form.Control as="textarea" rows={3} name="description" placeholder={`${sectionLabels.singular} Description`} size="sm" value={editingConnector?.description} onChange={handleFieldChange} />
        </Form.Group>

        <Form.Group className="mb-3" controlId="connector-connectorUrl">
          <Form.Label>URL</Form.Label>
          <Form.Control name="connectorUrl" placeholder={`${sectionLabels.singular} URL`} size="sm" value={editingConnector?.connectorUrl} onChange={handleFieldChange} required />
          <Form.Control.Feedback type="invalid">{sectionLabels.singular} URL is required.</Form.Control.Feedback>
        </Form.Group>
      </Modal.Body>

      <Modal.Footer className="justify-content-between">
        <Button type="button" variant="light" size="sm" className="border" onClick={onCancel}>Close</Button>
        <Button type="submit" variant="success" size="sm">
          <FontAwesomeIcon icon={solid('save')} />
          <span className="ms-2">Save</span>
        </Button>
      </Modal.Footer>
    </Form>
  )
}